export default "__VITE_ASSET__DjhGTDfc__"